import {
  Home, Landmark, Coins, Car, Building2, Briefcase, GraduationCap,
  HeartPulse, ShoppingCart, IndianRupee, Wallet, Tractor, Gem, Repeat,
} from "lucide-react";

// Curated set of lucide icons the admin can pick per loan product.
// The key is stored on the loan record; the frontend maps it to a component.
export const LOAN_ICON_MAP = {
  home:       { Icon: Home,          label: "Home" },
  landmark:   { Icon: Landmark,      label: "Property" },
  gem:        { Icon: Gem,           label: "Gold / Jewel" },
  repeat:     { Icon: Repeat,        label: "Take Over" },
  briefcase:  { Icon: Briefcase,     label: "Business" },
  car:        { Icon: Car,           label: "Vehicle" },
  building:   { Icon: Building2,     label: "Commercial" },
  wallet:     { Icon: Wallet,        label: "Personal" },
  tractor:    { Icon: Tractor,       label: "Agriculture" },
  graduation: { Icon: GraduationCap, label: "Education" },
  heart:      { Icon: HeartPulse,    label: "Medical" },
  cart:       { Icon: ShoppingCart,  label: "Consumer" },
  coins:      { Icon: Coins,         label: "Coins" },
};

// Fallback: guess an icon from the loan name so old data still looks nice.
function guess(name = "") {
  const n = name.toUpperCase();
  if (n.includes("HOME"))                       return "home";
  if (n.includes("LAP") || n.includes("PROP"))  return "landmark";
  if (n.includes("GOLD") || n.includes("JEWEL"))return "gem";
  if (n.includes("TAKE OVER") || n === "TO")    return "repeat";
  if (n.includes("BUSINESS"))                   return "briefcase";
  if (n.includes("VEHICLE") || n.includes("CAR")|| n.includes("AUTO")) return "car";
  if (n.includes("PERSONAL") || n === "PL")     return "wallet";
  if (n.includes("AGRI") || n.includes("FARM")) return "tractor";
  if (n.includes("EDU"))                        return "graduation";
  if (n.includes("MED") || n.includes("HEALTH"))return "heart";
  return "coins";
}

/** Returns a lucide component for a loan (uses stored `icon` or best-guess). */
export function LoanIcon({ loan, name, className = "w-4 h-4" }) {
  const key = (loan?.icon || guess(loan?.name || name || "")) || "coins";
  const spec = LOAN_ICON_MAP[key] || LOAN_ICON_MAP.coins;
  const Cmp = spec.Icon;
  return <Cmp className={className} />;
}
